__webpack_require__.p = "/captains_logs/";